import { useEffect } from "react";
import HeroWhite from "@/components/home_v2/HeroWhite";
import ValueProp from "@/components/home_v2/ValueProp";
import TechPartnersMarquee from "@/components/home_v2/TechPartnersMarquee";
import Challenges from "@/components/home_v2/Challenges";
import RockLadderApproachBand from "@/components/home_v2/RockLadderApproachBand";
import HowWeHelp from "@/components/home_v2/HowWeHelp";
import SOCList from "@/components/home_v2/SOCList";
import WhyMetrics from "@/components/home_v2/WhyMetrics";
import CertifiedExpertise from "@/components/home_v2/CertifiedExpertise";
import Testimonials from "@/components/home_v2/Testimonials";
import FinalCTA from "@/components/home_v2/FinalCTA";
import { useSEO } from "@/lib/seo";

export default function Home() {
  useSEO({
    title: "RockLadder Technologies — Resilience for a Changing World",
    description:
      "RockLadder is a next-generation managed cybersecurity partner. We Consult, Implement, Manage, and Test across your entire security landscape — with a 24×7 SOC and best-in-class technology partners.",
    canonical: "https://rockladder.com/",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "RockLadder Technologies",
      url: "https://rockladder.com/",
      description:
        "End-to-end cybersecurity solutions — Consult, Implement, Manage, Test. 24×7 SOC. AI-augmented threat detection.",
      sameAs: ["https://www.linkedin.com/"],
      address: {
        "@type": "PostalAddress",
        addressLocality: "Noida",
        addressCountry: "IN",
      },
    },
  });

  // Home wraps its own theme, but also swap document-level background so
  // preloader / header / footer visually harmonize on home.
  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    html.classList.add("home-white");
    body.classList.add("home-white");
    body.style.background = "#FFFFFF";
    return () => {
      html.classList.remove("home-white");
      body.classList.remove("home-white");
      body.style.background = "";
    };
  }, []);

  return (
    <div data-testid="home-page" className="theme-editorial bg-white text-[#111]">
      <HeroWhite />
      <ValueProp />
      <TechPartnersMarquee />
      <Challenges />
      <RockLadderApproachBand />
      <HowWeHelp />
      <SOCList />
      <WhyMetrics />
      <CertifiedExpertise />
      <Testimonials />
      <FinalCTA />
    </div>
  );
}
